module.exports = __webpack_public_path__ + "img/Docker64_128.b05f8189.png";